module.exports = "https://vote4-campaigns-cdn.fire-emblem-heroes.com/images/src/assets/images/mypage/fr-CA/txt_wp-6times.png";